import React from "react";
import { useDispatch } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import Button from "../../components/Button";
import Logo from "../../components/Logo";
import Modal from "../../components/Modal";
import {
  ROUTE_ACCOUNTS,
  ROUTE_HOME,
  ROUTE_SETTINGS,
  ROUTE_TRANSACTIONS,
} from "../../routes";
import { logout } from "../../store/modules/user/actions";
import Accounts from "../Accounts";
import Home from "../Home";
import Settings from "../Settings";
import Transactions from "../Transactions";
import Header from "./components/Header";
import SideNav from "./components/SideNav";

function App() {
  return (
    <div className="flex h-full bg-gray-100">
      <WaitListModal />
      <SideNav />
      <div
        className="flex-auto bg-white pt-8 px-10 shadow-md flex flex-col"
        style={{
          borderTopLeftRadius: "1.5rem",
          borderBottomLeftRadius: "1.5rem",
        }}
      >
        <Header />
        <div className="pt-6 flex-auto">
          <Switch>
            <Route path={ROUTE_HOME}>
              <Home />
            </Route>
            <Route path={ROUTE_ACCOUNTS}>
              <Accounts />
            </Route>
            <Route path={ROUTE_TRANSACTIONS}>
              <Transactions />
            </Route>
            <Route path={ROUTE_SETTINGS}>
              <Settings />
            </Route>
            <Redirect to={ROUTE_HOME} />
          </Switch>
        </div>
      </div>
    </div>
  );
}

const WaitListModal = () => {
  const dispatch = useDispatch();
  return (
    <Modal isOpen>
      <div className="p-8 relative" style={{ width: 600 }}>
        <div className="absolute top-4 left-4">
          <Logo size={20} type="plain" />
        </div>
        <div className="prose prose-lg text-center">
          <h3> Thank You for Joining the Wait List!</h3>
          <p>
            Here at Due we are working hard to bring you the next revolutionary
            retirement plans. Please bear with us as we are working hard to
            create the best experience for our users. We will reach out when we
            launch!
          </p>
        </div>
        <div className="flex justify-center mt-6">
          <Button size="lg" onClick={() => dispatch(logout())}>
            Log Out
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default App;
